import { AlphaNumericCaseInsensitive, UiLanguageSwitchConst } from '@/configuration';
import ng from 'angular';
import {
    ValidateAllowedCharacters,
    ValidateMaxLength,
    ValidateMinLength,
    ValidateNotEmpty,
    AuthContextService
} from '@/services';
import { ShortLangType } from '@/configuration';
import { FormDropDownItems } from '@/atomic-components';

export class OrganEditPanelMachineOsController {
    public static $inject: string[] = ['$translate', '$timeout', 'userSettingsManager'];

    public machine: any;
    public operatingSystems: any;
    public selectedApp: any;
    public language: ShortLangType;
    public password: string;
    public sshKey: string;
    public extraUserName: string;
    public extraUserPass: string;
    public extraUserKeys: string;
    public dataLossConfirmed = false;
    public extraUserRequiredForInstallation = false;
    public userNameValidationInstructions: {}[];
    public dropdownLanguageItems: FormDropDownItems[] = [];
    public defaultLocale: ShortLangType;

    constructor(
        private $translate: ng.translate.ITranslateService,
        private $timeout: ng.ITimeoutService,
    ) {}

    public $onInit() {
        this.language = AuthContextService.user.language as ShortLangType;
        this.defaultLocale = this.language;
        for (const lang in UiLanguageSwitchConst) {
            this.dropdownLanguageItems.push(
                {
                    name: this.$translate.instant(UiLanguageSwitchConst[lang].translationId),
                    value: lang,
                }
            );
        }
        this.userNameValidationInstructions = [
            {
                settings: null,
                validator: new ValidateMinLength(this.$translate, 4)
            },
            {
                settings: null,
                validator: new ValidateMaxLength(this.$translate, 12)
            },
            {
                settings: null,
                validator: new ValidateNotEmpty(this.$translate)
            },
            {
                settings: null,
                validator: new ValidateAllowedCharacters(AlphaNumericCaseInsensitive, this.$translate)
            }
        ];
    }

    public checkExtraUserRequired = () => {
        this.$timeout(() => {
            if (this.selectedApp?.general !== undefined) {
                const match = /ubuntu/.exec(this.selectedApp.general.pkgName);
                this.extraUserRequiredForInstallation = match !== null;
            }
        });
    };

    public get showSavePanel() {
        return this.selectedApp !== undefined && this.password !== undefined && this.dataLossConfirmed;
    }
}

export class OrganEditPanelMachineOsComponent implements ng.IComponentOptions {
    public bindings = {
        operatingSystems: '<',
        selectedApp: '=',
        password: '=',
        sshKey: '=',
        extraUserName: '=',
        extraUserPass: '=',
        extraUserKeys: '=',
        defaultLocale: '=',
    };
    public template = require('./machine-os.html');
    public controller = OrganEditPanelMachineOsController;
}
